import React from 'react';
import { Card, Badge, Button } from '../ui';

const formatDate = (dateStr) => {
  try {
    return new Date(`${dateStr}T00:00:00`).toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
    });
  } catch {
    return dateStr;
  }
};

// Card for a single sample event (athletics or fine arts).
const DemoEventCard = ({ event, district, onBuy }) => {
  const primary = district?.colors?.primary || '#1e3a8a';
  const accent = district?.colors?.accent || '#fbbf24';

  const category = event.sport || event.type;
  const subtitle = event.home
    ? `${event.home}${event.away ? ` vs ${event.away}` : ''}`
    : event.school;

  return (
    <Card hover className="flex flex-col h-full overflow-hidden">
      <div className="h-1.5 w-full" style={{ backgroundColor: accent }} />
      <div className="p-5 flex flex-col flex-grow">
        <div className="flex items-center justify-between mb-2.5">
          <Badge color={primary}>{category}</Badge>
          <span className="text-sm font-bold text-ink-700">{event.price}</span>
        </div>

        <h3 className="text-lg font-bold font-display text-ink-900 leading-snug">{event.title}</h3>
        {subtitle && <p className="text-sm text-ink-500 mt-1">{subtitle}</p>}

        <div className="mt-3 space-y-1 text-sm text-ink-500 flex-grow">
          <p>📅 {formatDate(event.date)} · {event.time}</p>
          {event.venue && <p>📍 {event.venue}</p>}
        </div>

        <Button
          onClick={() => onBuy(event)}
          className="mt-4 w-full text-white hover:opacity-90"
          style={{ backgroundColor: primary }}
        >
          Buy Tickets
        </Button>
      </div>
    </Card>
  );
};

export default DemoEventCard;
